{
  "labels": {
    "paste": "Indsæt",
    "pasteAsPlaintext": "Indsæt som klartekst",
    "pasteCharts": "Indsæt diagrammer",
    "selectAll": "Marker alle",
    "multiSelect": "Tilføj element til markering",
    "moveCanvas": "Flyt lærred",
    "cut": "Klip",
    "copy": "Kopier",
    "copyAsPng": "Kopier til klippebord som PNG",
    "copyAsSvg": "Kopier til klippebord som SVG",
    "copyText": "Kopiér til udklipsholder som tekst",
    "copySource": "Kopiér kilde til udklipsholder",
    "convertToCode": "Konvertér til kode",
    "bringForward": "Flyt fremad",
    "sendToBack": "Placer bagest",
    "bringToFront": "Placer forrest",
    "sendBackward": "Send bagud",
    "delete": "Fjern",
    "copyStyles": "Kopier stil",
    "pasteStyles": "Indsæt stil",
    "stroke": "Linje",
    "changeStroke": "Ændr stregfarve",
    "background": "Baggrund",
    "changeBackground": "Ændr baggrundsfarve",
    "fill": "Udfyld",
    "strokeWidth": "Linjebredde",
    "strokeStyle": "Linjeform",
    "strokeStyle_solid": "Solid",
    "strokeStyle_dashed": "Stiplet",
    "strokeStyle_dotted": "Prikket",
    "sloppiness": "Sjuskethed",
    "opacity": "Gennemsigtighed",
    "textAlign": "Tekstjustering",
    "edges": "Kanter",
    "sharp": "Skarp",
    "round": "Rund",
    "arrowheads": "Pilehoveder",
    "arrowhead_none": "Ingen",
    "arrowhead_arrow": "Pil",
    "arrowhead_bar": "Bjælke",
    "arrowhead_circle": "Cirkel",
    "arrowhead_circle_outline": "Cirkel (omrids)",
    "arrowhead_triangle": "Trekant",
    "arrowhead_triangle_outline": "Trekant (omrids)",
    "arrowhead_diamond": "Diamant",
    "arrowhead_diamond_outline": "Diamant (omrids)",
    "arrowhead_crowfoot_many": "Kragefod (mange)",
    "arrowhead_crowfoot_one": "Kragefod (én)",
    "arrowhead_crowfoot_one_or_many": "Kragefod (én eller mange)",
    "more_options": "Flere muligheder",
    "arrowtypes": "Pile type",
    "arrowtype_sharp": "Skarp pil",
    "arrowtype_round": "Buet pil",
    "arrowtype_elbowed": "Albuepil",
    "fontSize": "Skriftstørrelse",
    "fontFamily": "Skrifttypefamilie",
    "addWatermark": "Tilføj \"Lavet med Excalidraw\"",
    "handDrawn": "Hånd-tegnet",
    "normal": "Normal",
    "code": "Kode",
    "small": "Lille",
    "medium": "Mellem",
    "large": "Stor",
    "veryLarge": "Meget stor",
    "solid": "Solid",
    "hachure": "Skravering",
    "zigzag": "Zigzag",
    "crossHatch": "Krydsskravering",
    "thin": "Tynd",
    "bold": "Fed",
    "left": "Venstre",
    "center": "Centrere",
    "right": "Højre",
    "extraBold": "Extra fed",
    "architect": "Arkitekt",
    "artist": "Kunstner",
    "cartoonist": "Tegneserietegner",
    "fileTitle": "Filnavn",
    "colorPicker": "Farvevælger",
    "canvasColors": "Brugt på lærred",
    "canvasBackground": "Lærredsbaggrund",
    "drawingCanvas": "Tegnelærred",
    "clearCanvas": "Ryd lærred",
    "layers": "Lag",
    "actions": "Handlinger",
    "language": "Sprog",
    "liveCollaboration": "Live samarbejde...",
    "duplicateSelection": "Duplikér",
    "untitled": "Unavngivet",
    "name": "Navn",
    "yourName": "Dit navn",
    "madeWithExcalidraw": "Fremstillet med Excalidraw",
    "group": "Gruppér valgte",
    "ungroup": "Afgruppér valgte",
    "collaborators": "Samarbejdspartnere",
    "toggleGrid": "Slå gitter til/fra",
    "addToLibrary": "Føj til bibliotek",
    "removeFromLibrary": "Fjern fra biblioteket",
    "libraryLoadingMessage": "Indlæser bibliotek…",
    "libraries": "Gennemse biblioteker",
    "loadingScene": "Indlæser scene…",
    "loadScene": "Indlæs scene fra fil",
    "align": "Justér",
    "alignTop": "Juster til top",
    "alignBottom": "Juster til bund",
    "alignLeft": "Venstrejusteret",
    "alignRight": "Højrejustér",
    "centerVertically": "Centrér vertikalt",
    "centerHorizontally": "Centrér horisontalt",
    "distributeHorizontally": "Distribuer vandret",
    "distributeVertically": "Distribuer lodret",
    "flipHorizontal": "Vend horisontalt",
    "flipVertical": "Vend vertikalt",
    "viewMode": "Visningstilstand",
    "share": "Del",
    "showStroke": "Vis stregfarve-vælger",
    "showBackground": "Vis baggrundsfarve-vælger",
    "showFonts": "Vis skrifttypevælger",
    "toggleTheme": "Slå lys/mørkt tema til/fra",
    "theme": "Tema",
    "personalLib": "Personligt bibliotek",
    "excalidrawLib": "",
    "decreaseFontSize": "",
    "increaseFontSize": "",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "",
      "editEmbed": "",
      "create": "",
      "label": "",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": "",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "Kopier til klippebord",
    "copyLink": "",
    "save": "",
    "saveAs": "Gem som",
    "load": "",
    "getShareableLink": "Lav et delbart link",
    "close": "Luk",
    "selectLanguage": "Vælg sprog",
    "scrollBackToContent": "Scroll tilbage til indhold",
    "zoomIn": "Zoom ind",
    "zoomOut": "Zoom ud",
    "resetZoom": "Nulstil zoom",
    "menu": "",
    "done": "Færdig",
    "edit": "Rediger",
    "undo": "Fortryd",
    "redo": "Gendan",
    "resetLibrary": "Nulstil bibliotek",
    "createNewRoom": "Opret nyt rum",
    "fullScreen": "Fuld skærm",
    "darkMode": "Mørk tilstand",
    "lightMode": "Lys baggrund",
    "systemMode": "",
    "zenMode": "Zentilstand",
    "objectsSnapMode": "",
    "exitZenMode": "Stop zentilstand",
    "cancel": "Annuller",
    "saveLibNames": "",
    "clear": "Ryd",
    "remove": "Fjern",
    "embed": "",
    "publishLibrary": "",
    "submit": "Gem",
    "confirm": "Bekræft",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Dette vil rydde hele lærredet. Er du sikker?",
    "couldNotCreateShareableLink": "Kunne ikke oprette delbart link.",
    "couldNotCreateShareableLinkTooBig": "Kunne ikke oprette delbart link: scenen er for stor",
    "couldNotLoadInvalidFile": "Kunne ikke indlæse ugyldig fil",
    "importBackendFailed": "Import fra backend mislykkedes.",
    "cannotExportEmptyCanvas": "",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "",
    "errorRemovingFromLibrary": "",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "importLibraryError": "",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "lasso": "",
    "image": "",
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "library": "",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": ""
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Klik og træk, slip når du er færdig",
    "text": "",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "<button></button> Kopiere og indsæt venligst oplysningerne nedenfor i et GitHub problem.",
    "sceneContent": "Scene indhold:"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "Live-samarbejde session er nu begyndt.",
    "desc_shareLink": "Del dette link med enhver, du ønsker at samarbejde med:",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Fejl"
  },
  "exportDialog": {
    "disk_title": "Gem til disk",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "Læs vores blog",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "shapes": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "",
    "version": "",
    "versionCopy": "Klik for at kopiere",
    "versionNotAvailable": "",
    "width": "Bredde"
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "Kopieret stilarter.",
    "copyToClipboard": "Kopieret til klippebord.",
    "copyToClipboardAsPng": "Kopieret {{exportSelection}} til klippebord som PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Fil gemt.",
    "fileSavedToFilename": "Gemt som {filename}",
    "canvas": "",
    "selection": "markering",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
